<template>
  <div class="npc-position-selector">
    <label>Position</label>
    <md-field>
      <md-select
        placeholder="Select Position"
        aria-label="Select Position"
        data-testid="select-position-button"
        :value="positionValue"
        :disabled="readonly || !!lockedPosition"
        :readonly="readonly || !!lockedPosition"
        @input="updatePosition"
      >
        <md-option
          v-for="stance in stanceOptions"
          :key="stance.value"
          :value="stance.value"
          :aria-label="stance.label + ' position'"
          :data-testid="'position-option-' + stance.value.toLowerCase()"
        >
          {{ stance.label }}
        </md-option>
      </md-select>
    </md-field>
  </div>
</template>

<script>

import { STANCE_LABELS } from '~lib/common/utils/labels';

export default {
  name: 'npc-position-selector',
  props: {
    position: {
      type: String,
      default: null,
    },
    defaultNpcStance: {
      type: String,
      default: null,
    },
    availableNpcStances: {
      type: Array,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    lockedPosition() {
      if (this.stanceOptions && this.stanceOptions.length === 1) {
        return this.stanceOptions[0].value;
      }
      return null;
    },
    positionValue() {
      return this.lockedPosition || this.position || this.defaultNpcStance;
    },
    stanceOptions() {
      const stances = this.availableNpcStances || ['STAND'];
      return stances.map(value => ({ value, label: STANCE_LABELS[value] || value }));
    },
  },
  methods: {
    updatePosition(value) {
      if (!value) return;
      this.$emit('update', value);
    },
  },
};
</script>

<style scoped>
.npc-position-selector {
  width: 100%;
  margin-right: 10px;
}
</style>
